import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const NewLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLoginClick = async () => {
    try {
      setLoading(true);
      setError('');

      const result = await login(email, password);

      if (result.success) {
        // Usar replace para evitar problemas de historial
        navigate('/dashboard', { replace: true });
      } else {
        console.error('❌ Login failed:', result.error);
        setError(result.error || 'Error de autenticación');
      }
    } catch (error) {
      console.error('❌ Unexpected error:', error);
      setError('Error inesperado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Login Simplificado</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border rounded-lg"
            placeholder="test@test.com"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border rounded-lg"
            placeholder="test123"
          />
        </div>

        <button
          onClick={handleLoginClick}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Iniciando...' : 'Iniciar Sesión'}
        </button>

        <p className="mt-4 text-sm text-gray-600">
          Versión simplificada para debugging - Sin formulario, solo botón directo
        </p>
      </div>
    </div>
  );
};

export default NewLoginPage;